import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/421dacb8-a1ee-4601-b727-d5ac647c7d71";
export const REGISTER_URL = "https://a.ntrk2.com/a69e150a-11e8-4215-9288-ea5c1d666f2b";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bdeasy.loadprkw2a.com/download?openExternalBrowser=1&id=of8b4aniljsfqcw";

export * from "./codes";
export * from "./context";
